var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 139.262,
    height: 42.988,
    viewBox: "0 0 139.262 42.988",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:url(#a);}.b{fill:#e5e5e5;}.c,.d,.e{opacity:0.5;}.c{fill:url(#b);}.d{fill:url(#c);}.e{fill:url(#d);}.f{fill:url(#e);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.325,
    y1: 1.708,
    x2: 0.675,
    y2: -0.812,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#4e5a61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#566169"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#5a646c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#606a71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#646e75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#80888d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80888d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#fcfdfd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#f4f4f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#e5e6e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#d0d3d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#b5b9bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#949b9f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#80888d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80888d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fafafa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#ebeded"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#d3d6d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#b1b6b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#868e93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#80888d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80888d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 0.445,
    y1: 1.027,
    x2: 0.544,
    y2: 0.048,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#f2f3f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#d0d3d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#989fa3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#80888d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80888d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 0.323,
    y1: 3.079,
    x2: 0.674,
    y2: -1.626,
    xlinkHref: "#a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-28.026)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.026)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M139.7,173.575a2.16,2.16,0,0,1-.4,1.088,4.01,4.01,0,0,1-.793.83,9.66,9.66,0,0,1-1.944,1.164,27.583,27.583,0,0,1-4.252,1.5,83.689,83.689,0,0,1-8.818,1.828c-5.933.934-11.915,1.527-17.907,1.934a287.265,287.265,0,0,1-36.005.006c-6-.351-11.982-.952-17.935-1.738s-11.878-1.762-17.765-2.922c-2.943-.583-5.877-1.216-8.795-1.918s-5.82-1.474-8.694-2.352c-1.436-.442-2.867-.9-4.283-1.412s-2.825-1.048-4.207-1.659c-.691-.306-1.376-.629-2.051-.977s-1.347-.717-1.991-1.129A12.957,12.957,0,0,1,2,166.413a6.609,6.609,0,0,1-.818-.9,3.642,3.642,0,0,1-.593-1.159,2.493,2.493,0,0,1-.1-.7,2.309,2.309,0,0,1,.116-.722,2.918,2.918,0,0,1,.744-1.155,5.311,5.311,0,0,1,1-.763,9.236,9.236,0,0,1,1.063-.552,17.613,17.613,0,0,1,2.193-.785c.738-.214,1.481-.4,2.224-.554a75.837,75.837,0,0,1,8.983-1.251q2.251-.2,4.5-.325t4.506-.206c3-.106,6.008-.156,9.01-.177,6.006-.038,12.008.044,18,.207s11.991.41,17.98.719c3,.16,6,.343,8.99.577s5.987.481,8.975.786q8.964.905,17.858,2.39c5.923,1,11.818,2.183,17.629,3.7a82.116,82.116,0,0,1,8.595,2.694,27.324,27.324,0,0,1,4.078,1.924,9.371,9.371,0,0,1,1.812,1.365,3.907,3.907,0,0,1,.692.917A2.117,2.117,0,0,1,139.7,173.575Zm-.192-.013a1.917,1.917,0,0,0-.244-1.027,3.7,3.7,0,0,0-.661-.866,8.974,8.974,0,0,0-1.778-1.321,20.229,20.229,0,0,0-1.991-1.011c-.681-.3-1.374-.582-2.075-.839-1.4-.514-2.829-.962-4.268-1.361s-2.891-.761-4.349-1.091-2.924-.629-4.392-.908-2.942-.531-4.418-.77c-2.952-.481-5.914-.885-8.882-1.251s-5.939-.689-8.914-.987q-2.229-.221-4.463-.422t-4.466-.385q-4.468-.368-8.948-.662t-8.948-.5q-8.97-.427-17.941-.756c-5.98-.209-11.961-.37-17.94-.4q-4.483-.024-8.962.064c-2.983.065-5.965.172-8.941.364-1.486.1-2.969.217-4.445.378s-2.947.352-4.4.62c-.724.134-1.443.289-2.148.472a16.423,16.423,0,0,0-2.058.665,8.05,8.05,0,0,0-.944.453,4.248,4.248,0,0,0-.8.572,1.828,1.828,0,0,0-.495.7,1.312,1.312,0,0,0-.031.791,2.59,2.59,0,0,0,.405.837,5.549,5.549,0,0,0,.673.779,11.955,11.955,0,0,0,1.686,1.347,28.969,28.969,0,0,0,3.871,2.139,70.607,70.607,0,0,0,8.345,3.2q2.135.683,4.3,1.279t4.341,1.127c2.906.707,5.834,1.325,8.775,1.872,5.883,1.095,11.819,1.893,17.771,2.475s11.921.953,17.891,1.185,11.955.385,17.933.459,11.957.068,17.936-.086c2.988-.076,5.977-.192,8.961-.38s5.965-.434,8.933-.8c1.484-.185,2.964-.4,4.436-.658s2.936-.561,4.384-.933c.723-.186,1.443-.394,2.148-.63a20.745,20.745,0,0,0,2.083-.806,9.261,9.261,0,0,0,1.906-1.131,3.828,3.828,0,0,0,.756-.787A1.969,1.969,0,0,0,139.511,173.562Z",
    transform: "translate(-0.445 -142.033)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M218.019,7.052C215.294,3.9,212.628.731,205.814,0H192.508C185.677.731,183,3.9,180.27,7.052s-3.19,7.958-3.19,7.958V27.828s.457,4.862,3.19,8.041,5.405,6.384,12.237,7.12h13.306c6.814-.739,9.48-3.945,12.2-7.12s3.181-8.041,3.181-8.041V15.009S220.745,10.2,218.019,7.052ZM207.059,37.37c-2.727,3.656-7.89,3.24-7.89,3.24s-5.176.42-7.91-3.24-2.673-8.922-2.673-15.982c0-6.989-.06-12.2,2.673-15.821s7.91-3.208,7.91-3.208,5.163-.417,7.89,3.208,2.666,8.832,2.666,15.821C209.725,28.448,209.785,33.709,207.059,37.37Z",
    transform: "translate(-160.045)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M842.773,5.543c-2.733,3.608-2.674,8.8-2.674,15.757,0,7.03-.06,12.269,2.674,15.915a8.655,8.655,0,0,0,5.929,3.142h4.055c5.748-.1,6.757-6.751,6.757-6.751V23.342c0-.757-.594-.639-.594-.639h-3.36c-1.009,0-1.1,1.575-1.1,1.575v.833l-.446.565h-4.143l-.728-.713V21.011l.728-.787h20.569l.713.787V42.1l-.8.712H859.793l-.283-.49c-.237.445-1.768.49-1.768.49H844.017c-6.831-.736-9.505-3.925-12.237-7.093s-3.19-8.01-3.19-8.01V14.949s.457-4.791,3.19-7.927S837.185.729,844.017,0H860.55a11.18,11.18,0,0,1,5.019,1.144,11.3,11.3,0,0,1,5.58,9.218l-.535.495s-9.222.324-10.158,0-1.292-5.243-1.292-5.243a4.082,4.082,0,0,0-3.387-3.145h-7.356A8.553,8.553,0,0,0,842.773,5.543Z",
    transform: "translate(-748.87)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M209.873,174.234c.024,1.358.021,2.8.021,4.324,0,7.06.059,12.321-2.666,15.982s-7.89,3.24-7.89,3.24-5.179.42-7.91-3.24-2.673-8.922-2.673-15.982c0-1.65,0-3.2.028-4.655-5.573-.007-9.975.036-11.534.054V185s.457,4.862,3.189,8.041,5.405,6.384,12.237,7.12h13.306c6.814-.739,9.48-3.945,12.2-7.12S221.37,185,221.37,185l-.016-10.188C218.352,174.477,214.315,174.393,209.873,174.234Z",
    transform: "translate(-160.199 -157.171)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M672.709,1.2l-.639.653v41.32l.639.724h10.278l.668-.7V1.9l-.668-.668Z",
    transform: "translate(-607.41 -1.085)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M683.654,180.839v24.048l-.673.7H672.709l-.639-.724V180.1C674.765,180.262,680.35,180.6,683.654,180.839Z",
    transform: "translate(-607.41 -162.772)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M864.812,193.992c-1.641-.028-3.718-.335-5.46-.476v-.082h-.641a.187.187,0,0,0-.126-.1c-7.68-1.711-7.4-1.182-8.61-1.048-.123.014-.619.585-.83.814v3.951l.728.713h4.143l.445-.565v-.831s.089-1.575,1.1-1.575h3.505a.455.455,0,0,1,.219.074.628.628,0,0,1,.226.565V205.7s-1.009,6.657-6.757,6.751H848.7a8.655,8.655,0,0,1-5.929-3.142c-2.733-3.646-2.674-8.884-2.674-15.915v-1.854c-4.99-.505-9.161-.9-11.506-1.126v9.39s.457,4.841,3.189,8.006,5.405,6.361,12.237,7.1h13.726s1.531-.044,1.767-.49l.283.49h10.559l.8-.712V195.431C869.379,195.159,867.073,194.032,864.812,193.992Z",
    transform: "translate(-748.871 -172.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1.238,164.779a1.455,1.455,0,0,1-.013-.695,1.592,1.592,0,0,1,.362-.674A2.434,2.434,0,0,1,1.9,163.1a3.719,3.719,0,0,1,.371-.277,6.281,6.281,0,0,1,.866-.475,13.777,13.777,0,0,1,1.991-.707c.693-.2,1.4-.361,2.125-.505,1.443-.289,2.917-.493,4.4-.661s2.975-.3,4.472-.4c2.994-.2,6-.319,9.015-.392s6.03-.09,9.044-.077c6.036.028,12.075.187,18.113.394s12.075.473,18.111.763c3.013.14,6.025.317,9.034.51q2.257.147,4.511.319c1.5.114,3.006.231,4.507.359s3,.255,4.5.4,3,.284,4.5.436c3,.307,5.991.635,8.977,1.018s5.965.8,8.93,1.293q2.223.369,4.434.793c1.472.289,2.94.593,4.4.931s2.906.705,4.336,1.117,2.846.866,4.225,1.388c.69.261,1.368.544,2.03.852a18.087,18.087,0,0,1,1.915,1.022c.054.033.106.067.159.1l.408.02q-.211-.147-.426-.289a24.5,24.5,0,0,0-3.958-1.948,76.467,76.467,0,0,0-8.532-2.732c-5.8-1.533-11.726-2.721-17.682-3.728s-11.965-1.8-17.992-2.405q-4.522-.459-9.059-.794c-3.024-.233-6.051-.418-9.081-.577-6.048-.312-12.1-.566-18.161-.728s-12.123-.251-18.2-.212c-3.035.021-6.071.073-9.108.182q-2.277.081-4.555.213t-4.552.336a71.425,71.425,0,0,0-9.06,1.309c-.749.169-1.493.361-2.229.592a15.057,15.057,0,0,0-2.17.849,7.728,7.728,0,0,0-1.022.6,4.863,4.863,0,0,0-.471.376,3.661,3.661,0,0,0-.42.443,2.539,2.539,0,0,0-.529,1.1,2.222,2.222,0,0,0,0,.817Z",
    transform: "translate(-0.026 -142.701)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.5ee958955b5167a6354fbb50cda031bb.svg";
export { ForwardRef as ReactComponent };